import type { VoidFunctionComponent } from 'react';

import Icon, { icons } from '../../generic/Icon';

export type SourceIconProps = {
  isVendored: boolean;
};

export const SourceIcon: VoidFunctionComponent<SourceIconProps> = ({ isVendored }) => {
  if (isVendored) {
    return (
      <Icon icon={icons.boxesPacking} />
    );
  }
  return (
    <Icon icon={icons.boxArchive} />
  );
};
